import { Star } from "lucide-react";

import {
  NonFousableTooltipTarget,
  Tooltip,
  TooltipTrigger,
} from "@/components/tooltip";

export const STAR_FILL_CLASSES = "fill-[#F79009] text-[#F79009]";
export const STAR_EMPTY_CLASSES = "fill-bg-disabled text-border-secondary";

interface StarRatingDisplayProps {
  className?: string;
  round?: "floor" | "nearest";
  size?: number;
  value?: null | number;
}

export function StarRatingDisplay({
  className,
  round = "nearest",
  size = 16,
  value,
}: StarRatingDisplayProps) {
  if (!value) {
    return <span className="text-text-tertiary">—</span>;
  }

  const filled = round === "floor" ? Math.floor(value) : Math.round(value);
  const label = `${value.toFixed(1)} of 5 stars`;

  return (
    <TooltipTrigger delay={250}>
      <NonFousableTooltipTarget>
        <div
          aria-label={label}
          className={`flex items-center gap-0.5 w-fit ${className ?? ""}`}
          role="img"
        >
          {Array.from({ length: 5 }, (_, index) => (
            <Star
              className={
                index < filled ? STAR_FILL_CLASSES : STAR_EMPTY_CLASSES
              }
              data-testid={index < filled ? "star-filled" : "star-empty"}
              key={index}
              size={size}
            />
          ))}
        </div>
      </NonFousableTooltipTarget>
      <Tooltip>{label}</Tooltip>
    </TooltipTrigger>
  );
}
